import listParser from './parsers/list';
import toError from './parsers/error';

import * as http from '../../utils/http';
import { keysToSnakeCase, keysToCamelCase } from '@wix/wix-vod-shared/src/common/utils/object';

import publishStatuses from '../../constants/publish-statuses';
import channelTypes from '../../constants/channel-types';

import { lists as externalListsRequests } from './external-requests';


const excludedFields = [
  'videosCount', 'items', 'updatedTs', 'createdTs',
  'id', 'itemType', 'mediaStatus', 'featuredItem', 'hasChangesToPublish', 'publishedTs',
];


export function prepareListForSending(listData) {
  listData = keysToCamelCase(listData);

  const { externalCreatedTs, channelType } = listData;

  if (externalCreatedTs) {
    listData.externalCreatedTs = Math.round(externalCreatedTs.valueOf() / 1000);
  }

  let fieldsToExclude = excludedFields;
  if (!channelType || channelType === channelTypes.CHANNEL) {
    fieldsToExclude = [...excludedFields, 'coverUrl'];
  }

  return keysToSnakeCase(_.omit(listData, fieldsToExclude));
}


export default function (settings, adapterMethods) {

  const toList = _.partial(listParser, adapterMethods);

  function _getItemCoverUrl(item = {}) {
    const { customCoverUrl, coverUrl } = item;
    return customCoverUrl || coverUrl;
  }

  function _parseSuccessResponse(response) {
    const { data } = response;

    return _.assign({}, response, {
      data: toList(data),
    });
  }

  function _loadExternalListData(response) {
    const { data } = response;
    const { externalId, channelType, urlType } = data;

    const externalRequestMethod = externalListsRequests[`${channelType}.${urlType}`];

    if (!externalRequestMethod) {
      return response;
    }

    return externalRequestMethod(externalId, { noExtraChannelData: true })
      .then(function (externalResponse) {
        const externalData = _.omit(externalResponse.data[0], 'id', 'title', 'description');
        return {
          ...response,
          data: {
            ...response.data,
            ...externalData,
          },
        };
      });
  }

  function get(trigger, listId) {
    if (!listId) {
      return toError({
        status: 500,
        data: {
          errorCode: 500,
          errorDescription: 'no id provided',
        },
      });
    }

    return http.get(`${settings.apiUrl}/catalog/lists/${listId}`)
      .then(_parseSuccessResponse)
      .then(_loadExternalListData)
      .catch(toError);
  }


  function getPublic(trigger, listId) {
    return http.get(`${settings.apiUrl}/public/lists/${listId}/info`)
      .then(_parseSuccessResponse)
      .then(function (response) {

        // fix server bug - coverUrl is always null,
        // need to get cover url of featured of first video
        if (!response.data.customCoverUrl) {
          if (!response.data.coverUrl) {
            response.data.coverUrl = _getItemCoverUrl(response.data.featuredItem || {});
          }

          if (!response.data.coverUrl) {
            return adapterMethods.listItems.listPublic(trigger, listId, {
                noAdditionalRequests: true,
                paging: { size: 1 },
              })
              .then(function ({ data = [] }) {
                response.data.coverUrl = _getItemCoverUrl(data[0]);
                return response;
              })
              .catch(() => response);
          }
        }
        return response;
      })
      .then(_loadExternalListData)
      .catch(toError);
  }


  function getPaymentInfo(trigger, listId, data) {
    const { instance } = data;

    return http.post(`${settings.apiUrl}/public/lists/${listId}/member/info`, {
        params: { instance },
        data: {},
      })
      .then(keysToCamelCase)
      .catch(toError);
  }

  function getMediaUrls(trigger, listId, params) {
    return http.get(`${settings.apiUrl}/public/lists/play/${listId}`, { params })
      .then(response => response.data);
  }

  function create(trigger, listData) {
    listData = {
      mediaType: settings.mediaType,
      ...listData,
    };

    const data = prepareListForSending(listData);

    return http.post(`${settings.apiUrl}/catalog/lists`, { data })
      .then(_parseSuccessResponse)
      .then(response => _.merge({ data: listData }, response))
      .catch(toError);
  }

  function update(trigger, listData) {
    const { id } = listData;

    const data = prepareListForSending(listData);

    return http.put(`${settings.apiUrl}/catalog/lists/${id}`, { data })
      .then(_parseSuccessResponse)
      .then(response => _.merge({ data: listData }, response))
      .catch(toError);
  }


  function checkPublish(trigger, taskId) {
    return http.get(`${settings.apiUrl}/publisher/bg-op/tasks/${taskId}`)
      .catch(function (response) {
        if (response.status === 404) {
          // task not found === it's already finished
          return { data: { status: publishStatuses.SUCCEEDED } };
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        if (response.data.status !== publishStatuses.SUCCEEDED) {
          return Promise.reject();
        }
      });
  }

  function publish(trigger, listId) {
    return http.post(`${settings.apiUrl}/publisher/lists/${listId}/publish`)
      .then(_.property('data.task_id'));
  }

  return {
    get,
    getPublic,
    getPaymentInfo,
    getMediaUrls,
    create,
    update,
    checkPublish,
    publish,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/list.js